import Questions from './Questions';
import Features from './Features';
import Footer from './Footer';
import FreeTrial from './FreeTrial';
import Header from './Header';
import Main from './Main';
import Testimonial from './Testimonial';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Landing() {
  const [atualizar, setAtualizar] = useState(false);
  const navigate = useNavigate();

  // Autenticação agora vive em páginas dedicadas (nada de popup sobre a landing).
  const irParaEntrar = () => navigate('/entrar');
  const irParaCriarConta = () => navigate('/criar-conta');

  return (
    <div>
      <Header onLogin={irParaEntrar} onCreateAccount={irParaCriarConta} atualizar={atualizar} onAtualizar={setAtualizar} />
      <Main onClick={irParaCriarConta} />
      <Features />
      <Testimonial />
      <Questions />
      <FreeTrial onClick={irParaCriarConta} />
      <Footer />
    </div>
  );
}
